module.exports = __webpack_public_path__ + "images/trending-04c161998fc2ce42de008554f16fec7c.png";